var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { KeyboardDatePicker as MuiKeyboardDatePicker } from '@material-ui/pickers';
import { FiCalendar } from 'react-icons/fi';
import { makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function () { return ({
    root: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 6,
        },
    },
}); });
var DatePicker = function (_a) {
    var format = _a.format, props = __rest(_a, ["format"]);
    var classes = useStyles();
    return (React.createElement(MuiKeyboardDatePicker, __assign({ className: classes.root, keyboardIcon: React.createElement(FiCalendar, { color: "primary" }), format: format || 'dd/MM/yyyy', autoOk: true }, props)));
};
export default DatePicker;
//# sourceMappingURL=DatePicker.js.map